module.exports = __webpack_public_path__ + "img/avatar-placeholder.b9a8916a.jpg";